import { useEffect } from 'react'

import { Chats } from '../../firebase/collections'

import { getProperTeamType } from './helpers'

const useChatListenerUnreads = ({
  userRole,
  userUniqId,
  userBuildingId,
  dispatchAddUnreadConversationIds,
  dispatchRemoveFromUnreadConversationIds,
}) => {
  const buildingIdNumber =
    userBuildingId && typeof userBuildingId === 'object' ? userBuildingId.id : userBuildingId

  const currentUserRoleShort = getProperTeamType(userRole)

  const checkAccessForRole = (channel) => {
    switch (currentUserRoleShort) {
      case 'PMT':
        return ['PMT', 'FDC', 'MT', 'MTRQ'].includes(channel.responder)
      default:
        return channel.responder === currentUserRoleShort
    }
  }

  const getTeamTypesArrayDueToUserRole = () => {
    switch (currentUserRoleShort) {
      case 'PMT':
        return ['PMT', 'FDC', 'MT', 'MTRQ']
      default:
        return [currentUserRoleShort]
    }
  }

  useEffect(() => {
    if (['PropertyManager', 'ShiftManager', 'Staff'].includes(userRole)) {
      const unsubscribe = Chats.doc(`${buildingIdNumber}`)
        .collection('channelsWithLastMessage')
        .where('responder', 'in', getTeamTypesArrayDueToUserRole())
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            const channelChanged = change.doc.data()

            if (change.type === 'added' || change.type === 'modified') {
              if (checkAccessForRole(channelChanged) && !channelChanged.isRead) {
                dispatchAddUnreadConversationIds(change.doc.id)
              }
            }
            if (
              change.type === 'modified' &&
              checkAccessForRole(channelChanged) &&
              channelChanged.isRead
            ) {
              dispatchRemoveFromUnreadConversationIds(change.doc.id)
            }
          })
        })

      return () => {
        unsubscribe()
      }
    }
  }, [userUniqId, buildingIdNumber])
}

export default useChatListenerUnreads
